import React, { useEffect, useRef } from 'react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
interface ConfirmDialogProps {
  open: boolean;
  title: string;
  description: string;
  confirmLabel: string;
  onConfirm: () => void;
  onCancel: () => void;
}
export function ConfirmDialog({
  open,
  title,
  description,
  confirmLabel,
  onConfirm,
  onCancel
}: ConfirmDialogProps) {
  const reduceMotion = useReducedMotion();
  const confirmRef = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onCancel();
    };
    document.addEventListener('keydown', onKey);
    confirmRef.current?.focus();
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onCancel]);
  return <AnimatePresence data-id="element-25" data-mp="j51ylyhjy5ht">
      {open && <div className="fixed inset-0 z-[60] flex items-center justify-center px-5" data-id="element-26" data-mp="j637pxf0chww">
          <motion.button type="button" aria-label="Cancel" onClick={onCancel} className="absolute inset-0 bg-ink/30" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.15,
        ease: 'easeOut'
      }} data-id="element-27" data-mp="ed0e5pa8d8gp" />
          <motion.div role="alertdialog" aria-modal="true" aria-labelledby="confirm-title" aria-describedby="confirm-desc" initial={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={reduceMotion ? {
        opacity: 0
      } : {
        opacity: 0,
        scale: 0.98
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative w-full max-w-sm rounded-2xl border border-line bg-surface p-5" data-id="element-28" data-mp="1p88rjvjwqppu">
            <h2 id="confirm-title" className="text-base font-semibold text-ink" data-id="element-29" data-mp="30qjoet7iygc1">
              {title}
            </h2>
            <p id="confirm-desc" className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-30" data-mp="35njtp1wjvf23">
              {description}
            </p>
            <div className="mt-5 flex gap-3" data-id="element-31" data-mp="2z8cneep7ucwv">
              <button type="button" onClick={onCancel} className="min-h-[44px] flex-1 rounded-xl border border-line text-sm font-medium text-ink transition-colors duration-150 hover:bg-bg focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-32" data-mp="2z7b8fz52x69v">
                Keep going
              </button>
              <button ref={confirmRef} type="button" onClick={onConfirm} className="min-h-[44px] flex-1 rounded-xl bg-coral text-sm font-semibold text-white transition-colors duration-150 hover:bg-coral-strong focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-coral" data-id="element-33" data-mp="3hz44k2fg37lt">
                {confirmLabel}
              </button>
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}